angular.module('natgeo').controller('Level2PlanScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'CommonFunctions',
function Level2PlanScreen($scope, element, ScreenFactory, manager, container, CommonFunctions)
{
	var screen = ScreenFactory( 'level2_plan', element );
	
	screen.once('introBefore', function()
	{		
		anim8.save('planFadePartial', {
			keyframe: {
				from: {
					opacity: 1
				},
				to: {
					opacity: 0.6
				}
			}
		});
	});

	// The user must select a help before they can proceed, always
	screen.on('introBefore', function()
	{
		screen._next.addClass('hidden');
	});
	
	// Displays the help modal with the given name
	$scope.help = CommonFunctions.help( screen, 'next' );
	
	// The next screen is the build screen
	$scope.next = function()
	{
		manager.transition('level2_conveyor');
	};
	
	// The previous screen is the learn screen
	$scope.prev = function()
	{
		manager.transition('level2_learn');
	};
	
}]);